import { APIData, appFetch } from ".";

export const countriesAPI = {
  fetch() {
    return appFetch<APIData<Country[]>>("/countries");
  },
};
